export default __webpack_public_path__ + "static/media/socio-off.24358d4d.svg";